module.exports = __webpack_public_path__ + "static/media/times-octagon.158c04d5.svg";